import { h, Host } from "@stencil/core";
export class Tag {
    constructor() {
        this.removable = false;
        this.variant = "default";
        this.disabled = false;
        this.interactive = false;
        this.icon = undefined;
    }
    /**
     * Primary element reference
     */
    domNode;
    /**
     * Event emitted when tag button pressed if removable attribute present
     */
    uxRemove;
    handleClickRemove = (event) => {
        event.stopPropagation();
        this.uxRemove.emit();
    };
    handleKeyDown = (event) => {
        switch (event.key) {
            case "Enter":
                if (this.removable) {
                    event.stopPropagation();
                    this.uxRemove.emit();
                }
                break;
            case " ":
                event.preventDefault();
                if (this.removable) {
                    event.stopPropagation();
                    this.uxRemove.emit();
                }
                break;
            default:
                break;
        }
    };
    render() {
        const { removable, interactive, variant } = this;
        const isButton = removable || interactive;
        return (h(Host, { key: '511c811fe4f33b6f28d8c4ba0c6a652b7532fb21', class: {
                [`ux-tag--removable`]: removable,
                [`ux-tag--interactive`]: interactive,
                [`ux-tag--${variant}`]: variant !== "default"
            }, variant: variant, onClick: removable ? this.handleClickRemove : undefined, onKeyDown: isButton ? this.handleKeyDown : undefined, role: isButton ? "button" : undefined, tabindex: isButton ? 0 : undefined }, h("slot", { key: 'feb61c507d9fde14a2829b9b0c3149d0b91faa06', name: "extra" }), this.icon && h("ux-icon", { key: '37da51f83fb8a056ffc85562d5a16d7726cf0db1', name: this.icon, "aria-hidden": "true", "aria-label": "icon", weight: "normal" }), h("span", { key: 'b765aab26375ddc16d81e4cc8de4ebb130b3d714', class: "ux-tag__label" }, h("slot", { key: '703c9e9bc4524ab819162d6cde127c76a9c7d6a0' })), removable && h("ux-icon", { key: 'b3c7e2c5af9f8352953dc1f43a267f6f6994fb5e', name: "cross", "aria-hidden": "true", "aria-label": "removable", weight: "normal" })));
    }
    static get is() { return "ux-tag"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tag.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tag.css"]
        };
    }
    static get properties() {
        return {
            "removable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "false"
                        }],
                    "text": "Control visibility of closing x icon & enable uxRemove Event"
                },
                "attribute": "removable",
                "reflect": true,
                "defaultValue": "false"
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"default\" | \"secondary\" | \"inactive\"",
                    "resolved": "\"default\" | \"inactive\" | \"secondary\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Style variant of the tag"
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "\"default\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If set to true, the tag does not change it's appearance when hovered."
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            },
            "interactive": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If set to true, the tag is styled with the interactive variant.\nAn interactive tag has a pointer cursor, is focusable and can be accessed via keyboard."
                },
                "attribute": "interactive",
                "reflect": true,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | undefined",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Display a leading icon"
                },
                "attribute": "icon",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "uxRemove",
                "name": "uxRemove",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when tag button pressed if removable attribute present"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
}
//# sourceMappingURL=tag.js.map
